import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { downloadExcel, getStocksByInvoice } from '@/api/inventory-inwards-logs';
import { generateInvoice, viewDispatchInvoice } from '@/api/ledgers';
import Pagination from '@/components/Pagination/index.vue';
import moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.listLoading = false;
    this.downloadLoading = false;
    this.list = [];
    this.total = 0;
    this.dateRange = '';
    this.listQuery = {
      adminId: this.query.adminId,
      unitId: this.query.unitId,
      branchId: this.query.branchId,
      productId: this.query.productId,
      variationId: this.query.variationId,
      action: undefined,
      startDate: undefined,
      endDate: undefined,
      page: 1,
      limit: 10
    };
    this.statusColorMap = {
      Pending: 'warning',
      'Request Approval': 'primary',
      Approved: 'success',
      Rejected: 'danger'
    };
    this.actionOptions = [{
      label: 'INWARD',
      value: 'inward'
    }, {
      label: 'OUTWARD',
      value: 'outward'
    }];
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3; // April (0-indexed as 3 in moment.js)
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // If before April, move to the previous financial year
          startYear--;
        }
        const thisFinancialYearStart = moment([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = moment([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // Before April, use the previous financial year
          startYear--;
        }
        const lastFinancialYearStart = moment([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = moment([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
  }
  activated() {
    this.getList();
  }
  async getList() {
    this.listLoading = true;
    try {
      const data = await getStocksByInvoice(this.listQuery);
      this.list = data.data;
      this.total = data.total;
    } catch (error) {
      console.error(error);
    } finally {
      this.listLoading = false;
    }
  }
  async viewCNDNInvoice(id) {
    try {
      // get invoice url
      this.listLoading = true;
      const url = await generateInvoice(id);
      if (url) {
        window.open(url, '_blank');
      } else {
        this.$message({
          message: 'Failed to generate invoice',
          type: 'error'
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.listLoading = false;
    }
  }
  async viewDispatchInvoice(id) {
    try {
      // get invoice url
      this.listLoading = true;
      const url = await viewDispatchInvoice(id);
      if (url) {
        window.open(url, '_blank');
      } else {
        this.$message({
          message: 'Failed to generate invoice',
          type: 'error'
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.listLoading = false;
    }
  }
  async handleFilter() {
    if (this.dateRange) {
      this.listQuery.startDate = this.dateRange.start;
      this.listQuery.endDate = this.dateRange.end;
    }
    this.getList();
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    try {
      const blob = await downloadExcel(this.listQuery);
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'stock.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      this.$message.error('Error downloading Excel');
    } finally {
      // Reset loading state
      this.downloadLoading = false;
    }
  }
};
__decorate([Prop({
  type: Object,
  required: true
})], default_1.prototype, "query", void 0);
default_1 = __decorate([Component({
  name: 'InventoryInwardStock',
  components: {
    Pagination
  }
})], default_1);
export default default_1;